export const clientConstants = {
	LOADING_POINTS: 'LOADING_POINTS',
	POINTS_WAS_LOADED: 'POINTS_WAS_LOADED',
	GET_BALANCE_POINTS: 'GET_BALANCE_POINTS',
	GET_EXPIRING_POINTS: 'GET_EXPIRING_POINTS',
	GET_ABAILABLE_POINTS_TO_BUY: 'GET_ABAILABLE_POINTS_TO_BUY'
}
